// Entities Trademarks Management Permissions

export const ENTITIES_TRADEMARKS_INDEX = 202;
export const ENTITIES_TRADEMARKS_CREATE = 203;
export const ENTITIES_TRADEMARKS_UPDATE = 204;
export const ENTITIES_TRADEMARKS_DELETE = 205;
export const ENTITIES_TRADEMARKS_RESTORE = 1385;
